<template>
  <div id="app">
    <HeaderPage />
    <router-view/>
  </div>
</template>

<script>
import Vue from "vue";
import HeaderPage from '@/components/Header.vue';

export default Vue.extend({
  name: "App",
  components: {
    HeaderPage
  }
});
</script>

<style lang="scss">
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
</style>
